<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.00033 2.33335C5.31843 2.33335 2.33366 5.31812 2.33366 9.00002C2.33366 12.6819 5.31843 15.6667 9.00033 15.6667C12.6822 15.6667 15.667 12.6819 15.667 9.00002C15.667 5.31812 12.6822 2.33335 9.00033 2.33335ZM0.666992 9.00002C0.666992 4.39765 4.39795 0.666687 9.00033 0.666687C13.6027 0.666687 17.3337 4.39765 17.3337 9.00002C17.3337 13.6024 13.6027 17.3334 9.00033 17.3334C4.39795 17.3334 0.666992 13.6024 0.666992 9.00002ZM8.16699 5.66669C8.16699 5.20645 8.54009 4.83335 9.00033 4.83335H9.00866C9.4689 4.83335 9.84199 5.20645 9.84199 5.66669C9.84199 6.12692 9.4689 6.50002 9.00866 6.50002H9.00033C8.54009 6.50002 8.16699 6.12692 8.16699 5.66669ZM7.33366 9.00002C7.33366 8.53978 7.70676 8.16669 8.16699 8.16669H9.00033C9.46056 8.16669 9.83366 8.53978 9.83366 9.00002V11.5C10.2939 11.5 10.667 11.8731 10.667 12.3334C10.667 12.7936 10.2939 13.1667 9.83366 13.1667H9.00033C8.54009 13.1667 8.16699 12.7936 8.16699 12.3334V9.83335C7.70676 9.83335 7.33366 9.46026 7.33366 9.00002Z"
            fill="#6F7287"
        />
    </g>
</template>
<script>
export default {
    name: "InfoCircleGrey",
};
</script>
